// extracted by mini-css-extract-plugin
module.exports =  {"numberColumn":"TrendTables-module_numberColumn__ZNo2AZ8YwCzTwiNy63Fh"};